// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The full region catalogue row, for admin tooling — unlike Region, exposes cloud_provider, ingress_cluster_name, and the raw available flag rather than pre-splitting by provider.
 *
 * @export
 * @interface AdminRegion
 */
export interface AdminRegion {
  /**
   *
   * @type {string}
   * @memberof AdminRegion
   */
  cloudProvider: string;
  /**
   *
   * @type {string}
   * @memberof AdminRegion
   */
  regionId: string;
  /**
   *
   * @type {string}
   * @memberof AdminRegion
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof AdminRegion
   */
  ingressClusterName?: string;
  /**
   *
   * @type {boolean}
   * @memberof AdminRegion
   */
  available: boolean;
}

/**
 * Check if a given object implements the AdminRegion interface.
 */
export function instanceOfAdminRegion(value: object): value is AdminRegion {
  if (!('cloudProvider' in value) || value['cloudProvider'] === undefined)
    return false;
  if (!('regionId' in value) || value['regionId'] === undefined) return false;
  if (!('displayName' in value) || value['displayName'] === undefined)
    return false;
  if (!('available' in value) || value['available'] === undefined) return false;
  return true;
}

export function AdminRegionFromJSON(json: any): AdminRegion {
  return AdminRegionFromJSONTyped(json, false);
}

export function AdminRegionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdminRegion {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider: json['cloud_provider'],
    regionId: json['region_id'],
    displayName: json['display_name'],
    ingressClusterName:
      json['ingress_cluster_name'] == null
        ? undefined
        : json['ingress_cluster_name'],
    available: json['available'],
  };
}

export function AdminRegionToJSON(json: any): AdminRegion {
  return AdminRegionToJSONTyped(json, false);
}

export function AdminRegionToJSONTyped(
  value?: AdminRegion | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: value['cloudProvider'],
    region_id: value['regionId'],
    display_name: value['displayName'],
    ingress_cluster_name: value['ingressClusterName'],
    available: value['available'],
  };
}
